/*
 * @Author: your name
 * @Date: 2021-07-08 10:13:46
 * @LastEditTime: 2021-09-15 19:23:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \foxit_print\src\utils\utils.js
 */
import SparkMD5 from "spark-md5";
import { IAM_URL, REQUEST_URL } from "const";

/**
 * @description: 判断是否移动端
 * @param {*}
 * @return {*}
 */
export function isMobile() {
  return /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent);
}

export const BMF = {
  md5: function(file, md5Fn, progressFn) {
    this.aborted = false;
    this.progress = 0;
    let currentChunk = 0;
    const blobSlice =
      File.prototype.slice ||
      File.prototype.mozSlice ||
      File.prototype.webkitSlice;
    const chunkSize = 2097152;
    const chunks = Math.ceil(file.size / chunkSize);
    const spark = new SparkMD5.ArrayBuffer();
    const reader = new FileReader();
    loadNext();

    reader.onloadend = function(e) {
      spark.append(e.target.result); // Append array buffer
      currentChunk++;
      this.progress = currentChunk / chunks;

      if (progressFn && typeof progressFn === "function") {
        progressFn(this.progress);
      }

      if (this.aborted) {
        md5Fn("aborted");
        return;
      }

      if (currentChunk < chunks) {
        loadNext();
      } else {
        md5Fn(null, spark.end());
      }
    };

    /////////////////////////
    function loadNext() {
      const start = currentChunk * chunkSize;
      const end =
        start + chunkSize >= file.size ? file.size : start + chunkSize;
      reader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
  },

  abort: function() {
    this.aborted = true;
  },
};

export const asyncLoadJs = (url) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      script.onload = function() {
        resolve();
      };
    }
    script.src = url;
    document.body.appendChild(script);
  });
};

export const signIn = () => {
  localStorage.clear();
  window.location.href = `${IAM_URL}/login?cb=${encodeURIComponent(
    window.location.href
  )}&redirectUrl=${encodeURIComponent("https://www.foxitcloud.cn/singleSign")}`;
};

export const logout = () => {
  if (localStorage.getItem("loginType") === "iam") {
    window.location.href = `${IAM_URL}/logout.html?redirectUrl=${encodeURIComponent(
      "https://dy.foxitcloud.cn"
    )}`;
  } else {
    window.location.href = `${REQUEST_URL}/logout?url=${encodeURIComponent(
      "https://dy.foxitcloud.cn"
    )}`;
  }
  localStorage.clear();
};

export const sortAccountList = (data) => {
  // 假设data是一个包含上面数据的数组
  data.sort(function(a, b) {
    // 如果a的accountType是PERSONAL，而b不是，那么a排在b前面
    if (a.accountType === "PERSONAL" && b.accountType !== "PERSONAL") {
      return -1;
    }
    // 如果b的accountType是PERSONAL，而a不是，那么b排在a前面
    if (b.accountType === "PERSONAL" && a.accountType !== "PERSONAL") {
      return 1;
    }
    if (a.accountType === "PERSONAL" && b.accountType === "PERSONAL") {
      let aNum = Number(a.nickName);
      let bNum = Number(b.nickName);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        if (aNum < bNum) {
          return -1;
        }
        if (aNum > bNum) {
          return 1;
        }
        return 0;
      }
      let aHasSpecialChar = RegExp(
        /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
      ).test(a.nickName);
      let bHasSpecialChar = RegExp(
        /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
      ).test(b.nickName);
      if (!aHasSpecialChar && bHasSpecialChar) {
        return 1;
      }
      if (!bHasSpecialChar && aHasSpecialChar) {
        return -1;
      }
      return a.nickName.localeCompare(b.nickName, "en", {
        sensitivity: "base",
      });
    }
    if (
      !Object.prototype.hasOwnProperty.call(a, "accountType") &&
      Object.prototype.hasOwnProperty.call(b, "accountType")
    ) {
      return -1;
    }
    if (
      !Object.prototype.hasOwnProperty.call(b, "accountType") &&
      Object.prototype.hasOwnProperty.call(a, "accountType")
    ) {
      return 1;
    }
    if (
      (!Object.prototype.hasOwnProperty.call(a, "accountType") &&
        !Object.prototype.hasOwnProperty.call(b, "accountType")) ||
      (a.accountType !== "PERSONAL" && b.accountType !== "PERSONAL")
    ) {
      let aNum = Number(a.nickName);
      let bNum = Number(b.nickName);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        if (aNum < bNum) {
          return -1;
        }
        if (aNum > bNum) {
          return 1;
        }
        return 0;
      }
      let aHasSpecialChar = RegExp(
        /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
      ).test(a.nickName);
      let bHasSpecialChar = RegExp(
        /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
      ).test(b.nickName);
      if (!aHasSpecialChar && bHasSpecialChar) {
        return 1;
      }
      if (!bHasSpecialChar && aHasSpecialChar) {
        return -1;
      }
      return a.nickName.localeCompare(b.nickName, "en", {
        sensitivity: "base",
      });
    }
  });

  return data;
};
